import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import TimesheetService from "../../../../services/TimesheetService";
import moment from "moment";
import _ from 'lodash';
import {getNomeFluxosById} from "../../../../utils/enums";
import TarefaService from "../../../../services/TarefaService";
import {formatarValorReal} from "../../../../utils/formatar";


export default class HorasExtrasStore {

    @observable timesheet = {};
    @observable dadosMot = {};
    @observable totalHoras;
    @observable tiposHora;
    @observable listaLancamentoDias;
    @observable possiveisAcoes;
    @observable solicitacao;
    @observable observacoes;
    @observable idSolicitacaoExibicao;
    @observable admissao;
    @observable terminoContrato;
    @observable exibirGestorSolicitante;
    @observable exibeGestorSolicitante = false;
    @observable exibeDetalhesJustificativa = false;
    @observable taxaAdministracaoEtt;
    @observable comentarios;
    @observable tarefasFluxo;
    @observable gdvAlterado;
    @observable alocacoesProduto;
    @observable isGdvNull;
    @observable isAcheNull;
    @observable diaApuracaoControlePonto;


    constructor(tituloPaginaStore, loginStore, loadingPanelStore) {
        this.loadingPanelStore = loadingPanelStore;
        this.loginStore = loginStore;
        this.tituloPaginaStore = tituloPaginaStore;
        this.justificativasContratacao = [];
        this.timesheet = {
            lancamentosDias: [],
            dataInicio: null,
            dataFim: null,
            salarioBase: null,
            valorSalario: null,
            valoAche: 0,
            valorGdv: 0,
            descontoFaltas: 0,
            percentualGdv: null,
            totaisHorasExtras: []
        };
        this.taxaAdministracaoEtt = 0;
        this.observacoes = null;
        this.alocacoesProduto = [];
        this.possiveisAcoes = [];
        this.isGdvNull = true;
        this.isAcheNull = true;
        this.dadosMot = {
            nome: undefined,
            cpf: undefined
        };
        this.solicitacao = {
            id: undefined,
            cargo: {
                nome: undefined,
                salarioBase: undefined
            }
        };
        this.horasPorDia = 8;
        this.listaLancamentoDias = [];
        this.tiposHora = [];
        this.timesheetService = new TimesheetService();
        this.idSolicitacaoExibicao = null;
        this.comentarios = [];
        this.tarefasFluxo = [];
        this.tarefaService = new TarefaService();
        this.gdvAlterado = false;

        reaction(
            () => this.quantidadeFaltas,
            qntFaltas => {
                this.timesheet.descontoFaltas = this.timesheet.salarioBase ? (this.timesheet.salarioBase/30)*qntFaltas : 0;
            }
        );

        reaction(
            () => this.valorHora,
            () => {
                this.carregarTotaisHorasExtras();
            }
        )
    }

    verificarPeriodoEnvioTimesheetPermitido() {
        this.timesheetService.periodoEnvioTimesheetPermitido();
    }

    @computed get quantidadeDias() {
        if (this.timesheet && this.timesheet.dataInicio != null) {
            const dataInicio = moment(this.timesheet.dataInicio);
            const dataFim = moment(this.timesheet.dataFim);
            const diasTrabalhados = dataFim.diff(dataInicio, 'days')+1;
            return diasTrabalhados;
        }
        else {
            return 0;
        }
    }

    @computed get descricaoArDebito() {
        const numero = _.get(this.solicitacao, "centroCustoDebito");
        const nome = _.get(this.solicitacao, "nomeAreaDebito");

        if(numero && nome) {
            return numero + " - " + nome;
        } else {
            return numero;
        }
    }

    @computed get quantidadeDiasSalario() {
        if (this.timesheet && this.timesheet.dataInicio != null && this.diaApuracaoControlePonto) {
            const dataInicio = moment(this.timesheet.dataInicio);
            const dataFim = moment(this.timesheet.dataFim);
            const diasTrabalhados = dataFim.diff(dataInicio, 'days')+1;
            const diaInicioApuracao = this.diaApuracaoControlePonto;
            let dataInicioApuracao;

            if(moment(dataInicio).date() === diaInicioApuracao) {
                dataInicioApuracao = moment(dataInicio);
            } else if(moment(dataInicio).date() > diaInicioApuracao) {
                dataInicioApuracao = moment(dataInicio).date(diaInicioApuracao);
            } else if(moment(dataInicio).date() < diaInicioApuracao) {
                dataInicioApuracao = moment(dataInicio).date(diaInicioApuracao).add(-1, 'months');
            }

            let dataFinalApuracao = moment(dataInicioApuracao).add(1, 'months').add(-1, 'days');

            while(dataFinalApuracao < dataFim) {
                dataFinalApuracao = moment(dataFinalApuracao).add(1, 'months');
            }
            let diasPeriodoCompleto = dataFinalApuracao.diff(dataInicioApuracao, 'days')+1;

            return Math.round((diasTrabalhados/diasPeriodoCompleto) * 30.0);
        }
        else {
            return 0;
        }
    }

    @computed get labelPercentualAche() {
        return this.timesheet.percentualAche ? "(" + this.timesheet.percentualAche + "%)" : "";
    }

    @computed get labelPercentualGdv() {
        return this.timesheet.percentualGdv ? "(" + this.timesheet.percentualGdv + "%)" : "";
    }

    @computed get valorHora() {
        return this.timesheet.salarioBase && this.solicitacao.jornadaMensal ? this.timesheet.salarioBase / this.solicitacao.jornadaMensal : 0;
    }

    @computed get exibeRateioProdutos() {
        return this.alocacoesProduto && this.alocacoesProduto.length > 0;
    }


    /*@computed get jornadaEmRelacaoDiasApurador() {
            return this.solicitacao.jornadaMensal && this.quantidadeDiasSalario ? this.solicitacao.jornadaMensal * this.quantidadeDiasSalario / 30.0 : 0;
        }*/
    @computed get competencia() {
        if (this.timesheet) {
            return moment(this.timesheet.dataInicio).format('MMMM');
        }
    }

    @computed get quantidadeFaltas() {
        let faltas = 0;
        for (let lancamento of this.listaLancamentoDias) {
            if (lancamento.falta) {
                faltas = faltas + 1;
            }
        }
        return faltas;
    }

    @computed get exibeCampoGdvNoLancamentoHoras() {
        return (this.timesheet.percentualGdv && this.solicitacao.tipoGdv === "D") || (!this.isGdvNull && this.solicitacao.tipoGdv === "D");
    }

    /*@computed get totalHE() {
        const total = {horas: 0, valor: 0};
        if (this.listaLancamentoDias && this.listaLancamentoDias.length > 0) {
            for (let lancamentoDia of this.listaLancamentoDias) {
                if (!lancamentoDia.falta) {
                    for (let lancamentoHoras of lancamentoDia.lancamentosHoras) {
                        const valorLancamento = lancamentoHoras.quantidade * this.valorHora * (1 + lancamentoHoras.tipo.valor);
                        if (lancamentoHoras.quantidade && lancamentoHoras.tipo.codigo !== "HNOT") {
                            total.horas += lancamentoHoras.quantidade;
                            total.valor += valorLancamento;
                        }
                    }
                }
            }
        }
        return total;
    }*/

    @computed get quantidadeTotalHE() {
        let total = 0;
        for (let totalHoraExtra of this.timesheet.totaisHorasExtras) {
            if(!totalHoraExtra.codigo.includes("HNOT")) {
                total += totalHoraExtra.horas;
            }
        }
        return total;
    }

    @computed get quantidadeTotalHNOT() {
        let total = 0;
        for (let totalHoraExtra of this.timesheet.totaisHorasExtras) {
            if(totalHoraExtra.codigo.includes("HNOT")) {
                total += totalHoraExtra.horas;
            }
        }
        return total;
    }

    @computed get valorTotalHESemHNOT() {
        let total = 0;
        for (let totalHoraExtra of this.timesheet.totaisHorasExtras) {
            if(!totalHoraExtra.codigo.includes("HNOT")) {
                total += totalHoraExtra.valor;
            }
        }
        return total;
    }
    @computed get valorTotalHNOT() {
        let total = 0;
        for (let totalHoraExtra of this.timesheet.totaisHorasExtras) {
            if(totalHoraExtra.codigo.includes("HNOT")) {
                total += totalHoraExtra.valor;
            }
        }
        return total;
    }


    @computed get valorTotalHE() {
        let total = 0;
        for (let totalHoraExtra of this.timesheet.totaisHorasExtras) {
            total += totalHoraExtra.valor;
        }
        return total;
    }

    @computed get totaisHorasExtrasPorTipo() {
        const totaisHorasExtras = [];
        if (this.listaLancamentoDias && this.listaLancamentoDias.length > 0) {
            for (let lancamentoDia of this.listaLancamentoDias) {
                if (!lancamentoDia.falta) {
                    for (let lancamentoHoras of lancamentoDia.lancamentosHoras) {
                        if (lancamentoHoras.quantidade) {
                            totaisHorasExtras.push({
                                codigo: lancamentoHoras.tipo.codigo,
                                descricaoTipo: lancamentoHoras.tipo.descricao,
                                horas: lancamentoHoras.quantidade
                            });
                        }
                    }
                }
            }
        }
        return totaisHorasExtras;
    }

    @computed
    get exibeEmpregadosSubstituidos() {
        return this.solicitacao.justificativaContratacao && this.solicitacao.justificativaContratacao.motivoContratacao === "SUB"
    }

    @computed get exibeValorGdv() {
        return (this.timesheet.percentualGdv && !!this.solicitacao.tipoGdv) || !this.isGdvNull;
    }

    @computed get exibeValorAche() {
        return this.timesheet.percentualAche || !this.isAcheNull;
    }

    @computed get totalBruto() {
        const totalHE = this.valorTotalHE;
        const ache = this.timesheet.valorAche ? this.timesheet.valorAche : 0;
        const gdv = this.timesheet.valorGdv ? this.timesheet.valorGdv : 0;
        const insalubridade = this.timesheet.valorInsalubridade ? this.timesheet.valorInsalubridade : 0;
        const periculosidade = this.timesheet.valorPericulosidade ? this.timesheet.valorPericulosidade : 0;
        const gratificacao = this.timesheet.valorGratificacao ? this.timesheet.valorGratificacao : 0;
        const valorDsrHorasExtras = this.timesheet.valorDsrHorasExtras ? this.timesheet.valorDsrHorasExtras : 0;
        const dsrAdicionalNoturno = this.timesheet.valorDsrAdicionalNoturno ? this.timesheet.valorDsrAdicionalNoturno : 0;
        const descontoFaltas = this.timesheet.descontoFaltas ? this.timesheet.descontoFaltas : 0;
        const outrosDescontos = this.timesheet.valorOutrosDescontos ? this.timesheet.valorOutrosDescontos : 0;
        const outrosProventos = this.timesheet.valorOutrosProventos ? this.timesheet.valorOutrosProventos : 0;

        return this.timesheet.valorSalario + totalHE + ache + gdv + insalubridade + periculosidade + gratificacao + valorDsrHorasExtras + dsrAdicionalNoturno + outrosProventos - descontoFaltas - outrosDescontos;
    }

    @computed get VtVrAsoReembolsoViagens() {
        const vt = this.timesheet.valorVt ? this.timesheet.valorVt : 0;
        const vr = this.timesheet.valorVr ? this.timesheet.valorVr : 0;
        const aso = this.timesheet.valorAso ? this.timesheet.valorAso : 0;
        const reembolsoViagens = this.timesheet.valorReembolsoViagens ? this.timesheet.valorReembolsoViagens : 0;
        return vt + vr + aso + reembolsoViagens;
    }

    @computed get encargosEtt() {
        return this.taxaAdministracaoEtt ? this.totalBruto * this.taxaAdministracaoEtt/100 : 0;
    }

    @computed get totalGeral() {
        return this.totalBruto + this.VtVrAsoReembolsoViagens + this.encargosEtt;
    }

    @computed get descontoFaltas() {
        const descontoFaltas = this.timesheet.salarioBase ? (this.timesheet.salarioBase/30.0)*this.quantidadeFaltas : 0;
        return formatarValorReal(descontoFaltas);
    }

    @computed get quandidadeDiasGDV() {
        let count = 0;

        this.listaLancamentoDias.map((valor) => {
            if (valor && valor.gdv && !valor.falta) {
                count++;
            }
        });

        return count;
    }

    carregarTotaisHorasExtras(carregarValorDadoExterno = false) {
        const totaisHorasExtras = [];
        if (this.listaLancamentoDias && this.listaLancamentoDias.length > 0) {
            for (let lancamentoDia of this.listaLancamentoDias) {
                if (!lancamentoDia.falta) {
                    for (let lancamentoHoras of lancamentoDia.lancamentosHoras) {
                        const valorLancamento = lancamentoHoras.quantidade * this.valorHora * (lancamentoHoras.tipo.valor);
                        if (lancamentoHoras.quantidade) {
                            const dado = _.find(totaisHorasExtras, {codigo: lancamentoHoras.tipo.codigo});
                            const dadoExterno = _.find(this.timesheet.totaisHorasExtras, {codigo: lancamentoHoras.tipo.codigo});
                            const valorDadoExterno = dadoExterno ? dadoExterno.valor : 0;
                            if (dado) {
                                extendObservable(dado, {
                                    horas: dado.horas ? dado.horas + lancamentoHoras.quantidade : lancamentoHoras.quantidade
                                });
                                if(!carregarValorDadoExterno) {
                                    dado.valor = dado.valor + valorLancamento;
                                } else {
                                    dado.valor = valorDadoExterno;
                                }
                            } else {
                                totaisHorasExtras.push({
                                    codigo: lancamentoHoras.tipo.codigo,
                                    descricao: lancamentoHoras.tipo.descricao,
                                    tipoHoraId: lancamentoHoras.tipo.id,
                                    horas: lancamentoHoras.quantidade,
                                    valor: carregarValorDadoExterno ? valorDadoExterno : valorLancamento
                                });
                            }
                        }
                    }
                }
            }
        }
        this.timesheet.totaisHorasExtras = totaisHorasExtras;
    }





    carregarDados(taskId) {
        this.loadingPanelStore.setIsLoading("HorasExtrasLoading", true);
        const dadosPromise = Promise.all([
            this.carregarTiposHora(),
            this.carregarTimesheet(taskId)
        ]);

        dadosPromise.then(() => {
            this.loadingPanelStore.setIsLoading("HorasExtrasLoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("HorasExtrasLoading", false);
            console.log(error)
        });
    }

    carregarTimesheet(taskId) {
        return this.timesheetService.getByTaskId(taskId).then(response => {
            this.setDados(response.data);
        })
    }

    carregarDadosLotePagamento(timesheetId) {
        this.loadingPanelStore.setIsLoading("LotesPagamentoLoading", true);
        const dadosPromise = Promise.all([
            this.carregarTiposHora(),
            this.carregarLoteTimesheet(timesheetId)
        ]);

        dadosPromise.then(() => {
            this.loadingPanelStore.setIsLoading("LotesPagamentoLoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("LotesPagamentoLoading", false);
        });
    }

    carregarLoteTimesheet(timesheetId) {
        return this.timesheetService.getByTimesheet(timesheetId).then(response => {
            this.setDados(response.data);
        })
    }

    setDados(data) {
        this.detalhes = data;
        if(this.detalhes.timesheet) {
            if(!this.detalhes.timesheet.totaisHorasExtras) {
                this.detalhes.timesheet.totaisHorasExtras = [];
            }
            this.timesheet = this.detalhes.timesheet;
        }
        if(this.timesheet.valorGdv) {
            this.isGdvNull = false;
        }
        if(this.timesheet.valorAche) {
            this.isAcheNull = false;
        }
        this.dadosMot = this.detalhes.dadosMot;
        this.solicitacao = this.detalhes.solicitacao;
        this.solicitacao.motivoContratacao = this.solicitacao.justificativaContratacao.motivoContratacao;
        const alocacaoContrato = this.detalhes.alocacaoContrato;
        this.taxaAdministracaoEtt = alocacaoContrato.contrato.taxaAdministracaoEtt;
        this.admissao = alocacaoContrato.dataInicio;
        this.diaApuracaoControlePonto = alocacaoContrato.contrato.diaApuracaoControlePonto;
        this.terminoContrato = alocacaoContrato.dataTermino ? alocacaoContrato.dataTermino : alocacaoContrato.contrato.dataTermino;
        this.nomeTarefa = this.detalhes.definicaoTarefaId;
        this.possiveisAcoes = this.detalhes.possiveisAcoes ? this.detalhes.possiveisAcoes : [];
        this.idSolicitacaoExibicao = this.detalhes.idSolicitacaoExibicao;
        this.listaLancamentoDias = this.timesheet.lancamentosDias;
        this.alocacoesProduto = this.detalhes.alocacoesProduto;
        const titulo = data.definicaoTarefaName ? "Horas trabalhadas" + " - " + data.definicaoTarefaName : "Horas trabalhadas";
        this.tituloPaginaStore.setTitulo(titulo);
        const gestorSolicitante = this.detalhes.solicitacao.gestorSolicitante;
        this.exibirGestorSolicitante = gestorSolicitante != null ? `${gestorSolicitante.nome} (${gestorSolicitante.matricula})` : ``;
        const isValidacao = this.nomeTarefa === "HT_AvaliarHorasExtrasGestor";
        this.exibeGestorSolicitante = isValidacao;
        this.exibeDetalhesJustificativa = isValidacao;
        //this.listaLancamentoDias = response.data.lancamentoDias;

        if(data.definicaoTarefaId === "HT_LancarHorasExtrasETT") {
            if(this.timesheet.valorSalario == null) {
                this.timesheet.valorSalario = this.timesheet.salarioBase ? (this.timesheet.salarioBase/30.0)*this.quantidadeDiasSalario : 0;
            }

            if (!this.timesheet.valorGdv && this.timesheet.percentualGdv && this.solicitacao.tipoGdv === "F") {
                this.timesheet.valorGdv = this.timesheet.salarioBase * this.timesheet.percentualGdv / 100;
            }

            if (!this.timesheet.valorGdv && this.timesheet.percentualGdv && this.solicitacao.tipoGdv === "D") {
                this.timesheet.valorGdv = this.quandidadeDiasGDV*(this.timesheet.salarioBase/30.0)*(this.timesheet.percentualGdv/100.0);
            }
        }

        if(data.definicaoTarefaId === "HT_AjustarHorasExtrasETT" || data.definicaoTarefaId === "HT_LancarHorasExtrasETT") {
            this.possiveisAcoes.push("SALVAR_TIMESHEET");
        }

        if(_.get(this.detalhes.timesheet, "totaisHorasExtras")) {
            this.timesheet.totaisHorasExtras = this.detalhes.timesheet.totaisHorasExtras;
            this.carregarTotaisHorasExtras(true);
        }

        this.getComentarios();
        //this.getTarefasFluxo();
    }

    dadosValidosTimesheet() {
        if (this.listaLancamentoDias && this.listaLancamentoDias.length > 0) {
            const listaLancamentoDias = [];
            const listaLancamentoDiasClone = this.listaLancamentoDias.slice(0);
            const usuarioLogado = this.loginStore.usuarioLogado;
            const lancamentoMapeado = listaLancamentoDiasClone.map(
                lancamentoDia => {
                    if(lancamentoDia.observacaoUsuario !== null) {
                        if(lancamentoDia.observacoes == null) {
                            lancamentoDia.observacoes = [];
                        }
                        lancamentoDia.observacoes.push({nomeUsuario: usuarioLogado.nome, loginUsuario: usuarioLogado.login, observacao: lancamentoDia.observacaoUsuario})
                    }
                    const lancamento = {
                        observacoes: lancamentoDia.observacoes,
                        lancamentosHoras: [],
                        gdv: false,
                        totalHoras: 0,
                        falta: true,
                        data: lancamentoDia.data,
                        id: lancamentoDia.id,
                        timesheetId: lancamentoDia.timesheetId
                    };

                    if (!lancamentoDia.falta) {
                        lancamento.falta = false;
                        lancamento.gdv = lancamentoDia.gdv;
                        lancamento.totalHoras = lancamentoDia.totalHoras;
                        lancamento.lancamentosHoras = lancamentoDia.lancamentosHoras.slice(0).filter(
                            lancamentoHora => {
                                return lancamentoHora.quantidade !== 0;
                            }
                        ).map(
                            lancamentoHora => {
                                return {
                                    tipoHoraId: lancamentoHora.tipo.id,
                                    quantidade: lancamentoHora.quantidade
                                };
                            }
                        )
                    }
                    return lancamento;
                });
            return lancamentoMapeado.filter(
                lancamento => {
                    return (lancamento.gdv || lancamento.falta || lancamento.lancamentosHoras.length !== 0 || lancamento.observacoes);
                }
            );
        } else {
            return [];
        }
    }

    salvarTimesheet() {
        this.timesheet.lancamentosDias = this.dadosValidosTimesheet();
        this.timesheet.valorTotal = this.totalGeral;
        this.timesheet.valorEncargosEtt = this.encargosEtt;
        this.timesheet.totalBruto = this.totalBruto;

        return this.timesheetService.salvar(this.timesheet)
    }

    getComentarios() {
        if (this.timesheet && this.timesheet.id) {
            this.timesheetService.getHistorico(this.timesheet.id).then(response => {
                this.comentarios = response.data;
            }).catch(error => {
                console.log(error);
            });
        }
    }

/*    getTarefasFluxo(){
        if (this.timesheet && this.timesheet.id) {
            this.tarefaService.getTarefasFluxo("GloboMOTHoraExtra").then(response => {
                this.tarefasFluxo = response.data;
            }).catch(error => {
                console.log(error);
            });
        }
    } */

    setValorHEDadosResumo(value, codigo) {
        const he = _.find(this.timesheet.totaisHorasExtras, {codigo: codigo});
        he.valor = value;
    }

    /*setValorHNOTDadosResumo(value) {
        const heNoturnas = _.find(this.timesheet.totaisHorasExtras, {codigo: "HNOT"});
        if(heNoturnas) {
            heNoturnas.valor = value;
        } else {
            const tipoHoraNoturno = _.find(this.tiposHora, {codigo: "HNOT"});
            this.timesheet.totaisHorasExtras.push({
                codigo: "HNOT",
                descricao: tipoHoraNoturno.descricao,
                tipoHoraId: tipoHoraNoturno.id,
                horas: 0,
                valor: value,
            });
        }
    }*/

    setDescontoFaltas(value) {
        this.timesheet.descontoFaltas = value;
    }

    enviarAprovacao = (taskId) => {
        this.detalhes.timesheet = this.timesheet;
        this.detalhes.timesheet.lancamentosDias = this.dadosValidosTimesheet();
        this.detalhes.timesheet.valorTotal = this.totalGeral;
        this.detalhes.timesheet.totalBruto = this.totalBruto;
        this.detalhes.timesheet.valorEncargosEtt = this.encargosEtt;
        return this.timesheetService.tramitar(this.detalhes, "ENVIAR_APROVACAO", this.observacoes);
    };

    aprovar(id) {
        this.detalhes.timesheet = this.timesheet;
        this.detalhes.timesheet.lancamentosDias = this.dadosValidosTimesheet();
        return this.timesheetService.tramitar(this.detalhes, "APPROVE", this.observacoes);
    }

    demandarAjustes(id) {
        this.detalhes.timesheet = this.timesheet;
        this.detalhes.timesheet.lancamentosDias = this.dadosValidosTimesheet();
        this.detalhes.timesheet.valorTotal = this.totalGeral;
        this.detalhes.timesheet.valorEncargosEtt = this.encargosEtt;
        return this.timesheetService.tramitar(this.detalhes, "AJUSTE", this.observacoes);
    }

    setListaLancamentoDias(value, tipo) {
        this.listaLancamentoDias = value;
        this.carregarTotaisHorasExtras();
        if(tipo === "gdvChange") {
            this.carregarQuantidadeDiasGdv();
        }
    }

    carregarQuantidadeDiasGdv() {
        this.timesheet.valorGdv = this.quandidadeDiasGDV*(this.timesheet.salarioBase/30.0)*(this.timesheet.percentualGdv/100.0);
    }

    setDetailsValue(atribute, value) {
        this.timesheet[atribute] = value;
    }

    setValorSalario(value) {
        this.timesheet.valorSalario = value;
    }

    setObservacao(value) {
        this.timesheet.observacoesVerbasAdicionais = value;
    }

    setObservacoes(value) {
        this.observacoes = value;
    }

    carregarTiposHora() {
        return this.timesheetService.carregarTiposHora().then(response => {
            this.tiposHora = response.data;
        })
    }
}